import styled from "styled-components";

export const BlogContainer = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 20px;
  padding: 20px;
  max-width: 1500px;
  margin: auto;
  color: #282C34;

  @media (max-width: 550px) {
    /* Phones */
    grid-template-columns: 1fr;
  }

  @media (max-width: 1100px) {
    /* Tablets */
    grid-template-columns: 1fr;
  }
`;

export const MainContent = styled.div`
  background: #fff;
  padding: 20px;
  border-radius: 10px;

`;

export const RelatedPosts = styled.div`
  background: #f9f9f9;
  padding: 20px;
  border-radius: 10px;
`;

export const Title = styled.h1`
  font-size: 2rem;
  margin-bottom: 10px;
`;

export const Date = styled.p`
  color: gray;
  font-size: 0.9rem;
  margin-bottom: 20px;
`;

export const Content = styled.p`
  line-height: 1.6;
  font-size: 1.1rem;
`;

export const Image = styled.img`
  width: 100%;
  height: auto;
  border-radius: 10px;
  margin-bottom: 20px;
`;

export const RelatedPostItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
  cursor: pointer;
`;

export const RelatedImage = styled.img`
  width: 60px;
  height: 60px;
  border-radius: 5px;
  object-fit: cover;
`;

export const RelatedCaption = styled.p`
  font-size: 0.9rem;
  color: #333;
`;

export const Tags = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 20px;
  align-items: center;
`;

export const BlogPostContainer = styled.div`
  margin: auto;
  
`;